import React from 'react';
import Icon from '../../../components/AppIcon';

const ParticipantsSummary = ({ participants }) => {
  const getTransportIcon = (method) => {
    const icons = {
      driving: 'Car',
      walking: 'PersonStanding',
      'public-transit': 'Bus',
      bike: 'Bike'
    };
    return icons?.[method] || 'MapPin';
  };

  const getTransportLabel = (method) => {
    const labels = {
      driving: 'Driving',
      walking: 'Walking',
      'public-transit': 'Public Transit',
      bike: 'Biking'
    };
    return labels?.[method] || method;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6 shadow-md">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Users" size={20} className="text-primary" />
        <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground">
          Participants ({participants?.length})
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {participants?.map((participant, index) => (
          <div 
            key={participant?.id}
            className="flex items-center gap-3 p-3 bg-muted rounded-lg"
          >
            <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
              <Icon name={getTransportIcon(participant?.transportMethod)} size={20} className="text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground truncate">
                {participant?.name}
              </p>
              <p className="caption text-muted-foreground truncate">
                {participant?.location}
              </p>
              <p className="caption text-primary">
                {getTransportLabel(participant?.transportMethod)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ParticipantsSummary;